import axios from "axios";
import {API_BASE_URL} from "../config";

const API_URL = API_BASE_URL + '/auth/';

class AuthService {
    login(email, password, name) {
        return axios
            .post(API_URL + "signin", {
                email,
                password,
                name
            }, { headers: {
                    'Content-Type': 'application/json',
                    'application': 'bcm'
                }})
            .then(response => {
                console.log(response)
                if (response.data.accessToken) {
                    localStorage.setItem("user", JSON.stringify(response.data));
                }

                return response.data;
            }).catch((error) => {
                throw error;
            });
    }

    logout() {
        localStorage.removeItem("user");
    }

    getCurrentUser() {
        return JSON.parse(localStorage.getItem('user'));;
    }
}

export default new AuthService();
